var map = {
	"./100GBP.png": "2f9b",
	"./200AUD.png": "0bab",
	"./225JPY.png": "da58",
	"./AAPL.png": "93f1",
	"./ABT.png": "a49b",
	"./ADBE.png": "3829",
	"./AMGN.png": "75d7",
	"./AMZN.png": "7713",
	"./AUDUSD.png": "6d9e",
	"./BA.png": "e3f9",
	"./BAC.png": "45ac",
	"./BMY.png": "cb63",
	"./BRKb.png": "dee2",
	"./CAT.png": "28ff",
	"./CMCSA.png": "ae9d",
	"./CRM.png": "8383",
	"./CSCO.png": "d966",
	"./CVX.png": "5691",
	"./D30EUR.png": "502e",
	"./DIS.png": "4b08",
	"./EURUSD.png": "4353",
	"./F40EUR.png": "1fb8",
	"./GBPAUD.png": "7576",
	"./GBPJPY.png": "1f30",
	"./GBPUSD.png": "e5c9",
	"./GE.png": "43d9",
	"./GOOGL.png": "97379",
	"./GS.png": "583c",
	"./HD.png": "0afe",
	"./HON.png": "e048",
	"./HSIHKD.png": "d13f",
	"./IBM.png": "863d",
	"./INTC.png": "e8de",
	"./JNJ.png": "9511",
	"./JPM.png": "b07b",
	"./KO.png": "ce19",
	"./LLY.png": "00db",
	"./LMT.png": "792f",
	"./MA.png": "f2eb",
	"./MCD.png": "b449",
	"./MDT.png": "5944",
	"./META.png": "971f",
	"./MMM.png": "18b5",
	"./MRK.png": "19e2",
	"./MS.png": "351f",
	"./MSFT.png": "bed9",
	"./NASUSD.png": "2326",
	"./NEE.png": "c484",
	"./NFLX.png": "a4f8",
	"./NVDA.png": "dea6",
	"./NZDUSD.png": "3ae1",
	"./PEP.png": "353b",
	"./PFE.png": "ab98",
	"./PG.png": "13d6",
	"./PYPL.png": "5f57",
	"./RTX.png": "18cb",
	"./SPXUSD.png": "abae",
	"./TSLA.png": "3fbc",
	"./TXN.png": "800d",
	"./U30USD.png": "51a2",
	"./UNH.png": "d38b",
	"./USDCAD.png": "7d79",
	"./USDCHF.png": "6a1e",
	"./USDJPY.png": "7252",
	"./V.png": "e17f",
	"./VZ.png": "f6f1",
	"./WMT.png": "8e27",
	"./XAGUSD.png": "a0ba",
	"./XAUUSD.png": "0a0d",
	"./XBRUSD.png": "4e7b",
	"./XNGUSD.png": "26b4",
	"./XOM.png": "2a03",
	"./XTIUSD.png": "95a9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "48c8";